export const GET_GROUP_STATUSES_SUCCESS = 'GET_GROUP_STATUSES_SUCCESS';
export const SET_FETCHING_STATUSES = 'SET_FETCHING_STATUSES';